<div class="row">
    @for (field of customFields; track $index) {
        <div class="col-12" [class.col-md-6]="field.type !== fieldTypes.TITLE" [formGroup]="formGroup">
            @if (field.type !== fieldTypes.TITLE) {
                <label>{{ field.name }}<span *ngIf="field.required" class="required_asterisk"> *</span></label>
            }
            <app-custom-field-input
                [readonly]="false"
                *ngIf="field"
                [customField]="field"
                [type]="field?.type"
                (priceChanged)="priceChanged.emit($event)"
                formControlName="{{field.id.toString()}}"
                [class.error]="formGroup.get(field.id.toString())?.invalid && submitAttempted"
            />
            
            @if (field.description) {
                <small [innerHTML]="field.description" class="mt-1"></small>
            }

            <div class="mb-3 text-danger">
                <div *ngIf="formGroup.get(field.id.toString())?.hasError('required') && submitAttempted">
                    {{ 'RequiredField' | translate }}
                </div>
                <div *ngIf="formGroup.get(field.id.toString())?.hasError('format') && submitAttempted">
                    {{ 'IncorrectFormat' | translate }}
                </div>
            </div>
        </div>
    }
</div>
